import type React from 'react';

import ContentTitleSkeleton from '@/components/ContentTitleSkeleton';

import AllShowingDaysSliderSkeleton from './AllShowingDaysSliderSkeleton';

type ShowingListItemSkeletonProps = {
    selectedDate?: string | 'all';
};

/** Mirrors ShowingListItem's grid: one tree for both breakpoints, so it renders one slider skeleton, not two. */
const ShowingListItemSkeleton: React.FC<ShowingListItemSkeletonProps> = (props) => {
    return (
        <div className="grid grid-cols-1 gap-y-12 py-16 lg:grid-cols-[120px_480px_minmax(0,1fr)] lg:grid-rows-[auto_1fr_auto] lg:gap-x-24 lg:gap-y-16 lg:py-24 animate-pulse-skeleton">
            <div className="hidden lg:block lg:row-span-3 w-[120px] h-[180px] bg-[var(--surface-color)] rounded-8" />
            <div className="lg:col-start-2 lg:row-start-1">
                <ContentTitleSkeleton />
            </div>
            <div className="lg:hidden w-full h-210 bg-[var(--surface-color)] rounded-4" />
            <div className="hidden lg:flex lg:col-start-2 lg:row-start-2 flex-col space-y-4">
                <div className="w-full h-[20px] bg-[var(--surface-color)] rounded-4" />
                <div className="w-full h-[20px] bg-[var(--surface-color)] rounded-4" />
                <div className="w-full h-[20px] bg-[var(--surface-color)] rounded-4" />
            </div>
            <div className="lg:col-start-2 lg:row-start-3 w-1/2 h-[20px] bg-[var(--surface-color)] rounded-4" />
            <div className="flex min-w-0 lg:col-start-3 lg:row-start-1 lg:row-span-3">
                <AllShowingDaysSliderSkeleton selectedDate={props.selectedDate} />
            </div>
        </div>
    );
};

export default ShowingListItemSkeleton;
